import React from "react";

interface ClickableProps {
    onClick?: () => void;
    stopPropagation?: boolean;
    captureTouch?: boolean;
    children: React.ReactElement;
}

export const Clickable = ({ onClick, stopPropagation, captureTouch, children }: ClickableProps) => {
    const didTouchRef = React.useRef(false);
    const touchProps = captureTouch ? {
        onTouchStart: (e: React.TouchEvent) => { e.preventDefault(); if (stopPropagation) e.stopPropagation(); didTouchRef.current = true; onClick?.(); },
        onTouchEnd: (e: React.TouchEvent) => { e.preventDefault(); },
    } : {};
    return React.cloneElement(children, {
        ...touchProps,
        onContextMenu: (e: React.MouseEvent) => { e.preventDefault(); children.props.onContextMenu?.(e); },
        onClick: (e: React.MouseEvent) => { if (stopPropagation) e.stopPropagation(); if (!didTouchRef.current) onClick?.(); didTouchRef.current = false; },
    });
};
